
import { useNavigate } from 'react-router-dom';

export default function DashboardHeader() {
  const navigate = useNavigate();

  return (
    <header className="bg-white border-b border-gray-200 sticky top-0 z-40">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          <div className="flex items-center gap-3">
            <button
              onClick={() => navigate('/')}
              className="w-9 h-9 flex items-center justify-center rounded-lg hover:bg-gray-100 transition-colors cursor-pointer"
            >
              <i className="ri-arrow-left-line text-xl text-gray-600"></i>
            </button>
            <div className="flex items-center gap-2">
              <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-red-50">
                <i className="ri-dashboard-3-line text-lg text-red-600"></i>
              </div>
              <h1 className="text-lg font-bold text-gray-900" style={{ fontFamily: "'Noto Sans KR', sans-serif" }}>
                크롤러 대시보드
              </h1>
            </div>
          </div>
          <div className="flex items-center gap-2 text-xs text-gray-400">
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-shield-check-line text-sm"></i>
            </div>
            <span>관리자 전용</span>
          </div>
        </div>
      </div>
    </header>
  );
}
